var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-bottom":"50px","margin-top":"50px","text-align":"center","font-size":"14px"}},[_vm._v(" Copyright © "+_vm._s(new Date().getFullYear())+" © Copyright NYCU CSIT. All Rights Reserved. ")])}
var staticRenderFns = []

export { render, staticRenderFns }